/**
 * window.print() prints the whole application: sidebar, topbar, buttons and all. That is
 * not a receipt. This prints one element, sizes the paper for it, and names the file after
 * the document so "Save as PDF" offers SPA-W1-000142.pdf rather than the page title.
 */
export function printElement(element, { title, page = 'size: auto; margin: 12mm;' } = {}) {
  if (!element) return;

  const previousTitle = document.title;
  const style = document.createElement('style');
  style.setAttribute('data-print-rules', '');
  style.textContent = `@page { ${page} }`;

  // The browser uses document.title as the default filename when saving to PDF.
  if (title) document.title = title;
  document.head.appendChild(style);
  element.classList.add('print-target');

  let done = false;
  const cleanup = () => {
    if (done) return;
    done = true;
    element.classList.remove('print-target');
    style.remove();
    document.title = previousTitle;
    window.removeEventListener('afterprint', cleanup);
  };

  window.addEventListener('afterprint', cleanup);
  window.print();
  // afterprint is not fired reliably everywhere, so do not leave the page in print state.
  setTimeout(cleanup, 2000);
}

/** 80mm thermal paper, no margins. What the Premax printer actually feeds. */
export const RECEIPT_PAGE = 'size: 80mm auto; margin: 0;';
